import { z } from 'zod';
import { DealActivityEventPriority, DealActivityEventType } from '@trnsact/trnsact-shared-types';

import { dateStringSchema } from '../../model';

export const createEventFormSchema = z
  .object({
    description: z.string(),
    allDay: z.boolean(),
    assignedTo: z.string(),
    endAt: dateStringSchema,
    endDate: dateStringSchema,
    startAt: dateStringSchema,
    startDate: dateStringSchema,
    eventType: z.nativeEnum(DealActivityEventType),
    priority: z.nativeEnum(DealActivityEventPriority),
    contactId: z.string().uuid({ message: 'Required' }),
    accountId: z.string().uuid({ message: 'Required' }),
    subject: z.string().min(1, 'Subject is required'),
  })
  .superRefine((data, ctx) => {
    if (data.allDay) {
      if (!data.startDate) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Start date is required', path: ['startDate'] });
      }

      if (!data.endDate) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End date is required', path: ['endDate'] });
      }

      if (data.startDate && data.endDate && new Date(data.endDate) < new Date(data.startDate)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End date must be after start date', path: ['endDate'] });
      }

      return;
    }

    if (!data.startAt) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Start is required', path: ['startAt'] });
    }

    if (!data.endAt) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End is required', path: ['endAt'] });
    }

    if (data.startAt && data.endAt && new Date(data.endAt) < new Date(data.startAt)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End must be after start', path: ['endAt'] });
    }
  });

export type CreateEventFormValues = z.infer<typeof createEventFormSchema>;

export const createEventFormDefaultValues: CreateEventFormValues = {
  description: '',
  endAt: null,
  subject: '',
  allDay: false,
  startAt: null,
  endDate: null,
  accountId: '',
  contactId: '',
  assignedTo: '',
  startDate: null,
  eventType: DealActivityEventType.Other,
  priority: DealActivityEventPriority.Medium,
};
